import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class OpportunitySyncService {
  getOpportunitySyncs({ profileIds, opportunityIds, cancelToken = null }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunity-sync`,
      { profileIds, opportunityIds },
      {
        cancelToken: cancelToken && cancelToken.token,
      },
    ).then((response) => response.data);
  }

  syncOpportunity({ profileId, opportunityId, fieldValues = {} }) {
    return ApiService.post(`${Config.api.document.url}api/v1/opportunity-sync/synchronize`, {
      opportunityId,
      opportunitySyncProfileId: profileId,
      fieldValues,
    }).then((response) => response.data);
  }

  syncOpportunities({ profileId, opportunityIds }) {
    return ApiService.post(`${Config.api.document.url}api/v1/opportunity-sync/synchronize-batch`, {
      opportunityIds,
      opportunitySyncProfileId: profileId,
    }).then((response) => response.data);
  }
}

export const opportunitySyncService = new OpportunitySyncService();
